export default __webpack_public_path__ + "static/brokers-image-2-afcf3242505d064c943c1968048369ee.png";